<template>
  <div class="pre">
    <div class="pre_content">
      <img alt="" src="@/assets/image/load.gif" style="width: 200px">
      <div class="pre_text">文件正在预处理中，请稍候……</div>
      <div class="pre_tips">程序正在加速处理中，请耐心等待<br/>很快将进入下一处理环节</div>
      <el-button
      v-if="!isFinished"
      type="primary"
           v-tracking="{module:'xsd_pdf',actionName: $trackConfig['xsd_pdf_revoke'],actionCode:'xsd_pdf_revoke'}" class="stop_btn"
          @click="cancelCheck">
        取消检查
      </el-button>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {getEvaluation, revoke_task} from "@/api/pdf";
export default {
  name: "prePage",
  computed: {
    ...mapState('pdf', ['evaluationData', 'processData', 'isFinished', "projectId", 'sign_name']),
    checkStatus() {
      if (this.evaluationData.status == '1') {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    async cancelCheck() {
      await revoke_task({
        project: this.projectId,
        sign_name: this.sign_name
      })
      this.$emit("revoke")
    },
    goStart() {
      this.$router.push("/")
    },
    ...mapMutations('pdf', ['setEvaluationData'])
  }
}
</script>


<style scoped lang="scss">
.pre{
  width:100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .pre_content{
    text-align: center;
    .pre_text {
      margin-top: 5px;
      height: 35px;
      font-size: 25px;
      font-weight: bold;
      line-height: 35px;
      color: #262626;

    }
    .pre_tips {
      height: 60px;
      line-height: 30px;
      font-size: 18px;
      color: #8c8c8c;
    }
  }
}
</style>

